import React, { useState, forwardRef, useEffect, useMemo } from "react";
import "../quotation/Forecast.scss";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import FetchData, { DeleteEntry, GetList, GetOne } from "../../providers/dataProvider";
import AddForecast from "../../components/quotation/AddForecast";
import AddForeCastItem from "../../components/quotation/AddForeCastItem";
import BulkForecastModal from "../../components/quotation/BulkForecastModal";
import ForecastViewModal from "../../components/quotation/ForecastViewModal";
import { PriceFormat,CurrencyConvertion, FormatValueDecimal, calculateNetPrice } from "../../utils/Validate"
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import { QuotationNotFound } from "../../components/common/QuotationNotFound";
import SkeletonForecastListing from "../../components/common/skeletonForecastListing";
// datepicker start
const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <input
    value={value}
    className="example-custom-input form-control"
    onClick={onClick}
    onChange={onChange}
    ref={ref}
  ></input>
));
// datepicker end

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const colourOptions = [
  { value: "ocean1", label: "Ocean" },
  { value: "blue", label: "Blue" },
  { value: "purple", label: "Purple" },
  { value: "red", label: "Red" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "green", label: "Green" },
  { value: "forest", label: "Forest" },
  { value: "slate", label: "Slate" },
  { value: "silver", label: "Silver" },
];

const Forecast = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [quotationData, setQuotationData] = useState({});
  const [quotationDetails, setQuotationDetails] = useState(null);
  const [distributertag, setDistributerTag] = useState([]);
  const [currentForecast, setCurrentForecast] = useState(null);
  const [currentQuotation, setCurrentQuotation] = useState(null);
  const [openForecast, setOpenForecast] = useState(false);
  const [quoteGeneral, setQuoteGeneral] = useState(null);
  const [showForecast, setShowForecast] = useState(false);
  const [currencyDetail, setCurrencyDetail] = useState({})
  const [openForecastItem, setOpenForecastItem] = useState(false);
  const [showForecastItem, setShowForecastItem] = useState(false);
  const [showForecastView, setShowForecastView] = useState(false);
  const [currentForecastView, setCurrentForecastView] = useState(null);
  const [selectedForecastIds, setSelectedForecastIds] = useState({});
  const [showBulkForecast, setShowBulkForecast] = useState(false);
  const [show, setShow] = useState(false);
  const [errorShow, setErrorShow] = useState({
      show: false,
      errorMessage: "",
  });
  const [loading, setLoading] = useState(true)
  const { data: currencyData } = FetchData("currency");

  useEffect(() => {
    if (location?.state?.id) {
      setLoading(true);
      const item = location?.state;
      setCurrentQuotation(item);
      setQuoteGeneral(location?.state?.quotegeneral)
      GetOne("quotation", { id: item?.id }, setQuotationDetails);
      GetList("forecast", { quoteId: item?.id }, (res) => {
        setQuotationData(res);
        setLoading(false); 
      });
    }
  }, [location?.state?.id]);
  const handleChanges = (selected) => {
    setDistributerTag(selected);
  };

  const OpenAddForecast = (item) => {
    setOpenForecast(true)
    setShowForecast(!showForecast)
    setCurrentForecast(item);
  };

  const OpenProductForecast = (item) => {
    if (!item?.id) return;

    const forecastSummary = forecastSummaryMap.get(String(item?.id));

    setCurrentForecast({
      ...(forecastSummary || {
        quotationId: currentQuotation?.id,
        quoteProductId: item?.id,
        quotedAmount: calculateNetPrice(item),
        quantity: item?.quantity,
        productGroupName: item?.productGroupName || item?.groupName,
        productName: item?.productName,
      }),
    });
    setOpenForecast(true);
    setShowForecast(true);
  };

  const OpenForecastView = (item) => {
    const forecastSummary = forecastSummaryMap.get(String(item?.id));
    if (!forecastSummary) return;

    setCurrentForecastView({
      ...forecastSummary,
      quotationId: currentQuotation?.id,
      quoteProductId: item?.id,
      quotedAmount: calculateNetPrice(item),
      quantity: item?.quantity,
      productGroupName: item?.productGroupName || item?.groupName,
      productName: item?.productName,
    });
    setShowForecastView(true);
  };

  const handleForecastAction = (item) => {
    if (!item?.id) return;

    if (selectedForecastIds?.[item?.id] && !isForecastedItem(item)) {
      openBulkForecast();
      return;
    }

    if (isForecastedItem(item)) {
      OpenForecastView(item);
      return;
    }

    OpenProductForecast(item);
  };

  const navigateToQuotationGeneral = () => {
    navigate("/quotation", {
      state: {
        row: quoteGeneral?.row,
        id: quoteGeneral?.id,
      },
    });
  };

  useEffect(() => {
    const currencyId =
      quotationDetails?.data?.currencyId ||
      currentQuotation?.row?.currencyId;
    setCurrencyDetail(
      currencyData?.find((item) => String(item?.id) === String(currencyId)) || {}
    );
  }, [currencyData, currentQuotation?.row?.currencyId, quotationDetails?.data?.currencyId])

  const currencyCode = currencyDetail?.shortCode || "";

  const quotationProducts = useMemo(
    () => quotationDetails?.data?.products || [],
    [quotationDetails?.data?.products]
  );

  const forecastSummaryMap = useMemo(
    () =>
      new Map(
        (quotationData?.data || []).map((item) => [
          String(item?.quoteProductId),
          item,
        ])
      ),
    [quotationData?.data]
  );

  const forecastedItemIds = useMemo(
    () =>
      new Set(
        (quotationData?.data || [])
          .filter((item) => Number(item?.forecastedAmount) > 0)
          .map((item) => item?.quoteProductId)
          .filter((id) => id !== undefined && id !== null)
          .map((id) => String(id))
      ),
    [quotationData?.data]
  );

  const isForecastedItem = (item) =>
    forecastedItemIds.has(String(item?.id));

  const selectableForecastItems = quotationProducts.filter(
    (item) => !isForecastedItem(item)
  );

  const selectedForecastItems = useMemo(
    () =>
      quotationProducts.filter(
        (item) => selectedForecastIds?.[item?.id] && !isForecastedItem(item)
      ),
    [quotationProducts, selectedForecastIds, forecastedItemIds]
  );
  const hasForecastedItems = forecastedItemIds.size > 0;
  const defaultForecastItem = useMemo(
    () => quotationProducts.find((item) => isForecastedItem(item)) || null,
    [quotationProducts, forecastedItemIds]
  );

  const isAllSelectableForecastSelected =
    selectableForecastItems.length > 0 &&
    selectableForecastItems.every((item) => selectedForecastIds?.[item?.id]);

  const isPartiallySelectableForecastSelected =
    !isAllSelectableForecastSelected &&
    selectableForecastItems.some((item) => selectedForecastIds?.[item?.id]);

  const toggleForecastSelection = (item) => {
    if (!item?.id || isForecastedItem(item)) return;

    setSelectedForecastIds((prev) => ({
      ...prev,
      [item.id]: !prev?.[item.id],
    }));
  };

  const toggleAllForecastSelection = () => {
    if (selectableForecastItems.length === 0) return;

    const shouldSelectAll = !isAllSelectableForecastSelected;
    const next = {};

    selectableForecastItems.forEach((item) => {
      next[item.id] = shouldSelectAll;
    });

    setSelectedForecastIds(next);
  };

  const openBulkForecast = () => {
    if (selectedForecastItems.length === 0) return;
    setShowBulkForecast(true);
  };

  const handleBulkForecastSaved = (savedItems = []) => {
    const firstItem = savedItems?.[0];

    setSelectedForecastIds({});
    setShowBulkForecast(false);
    if (currentQuotation?.id) {
      GetList("forecast", { quoteId: currentQuotation?.id }, (res) => {
        setQuotationData(res);

        if (!firstItem) return;

        const forecastSummary = (res?.data || []).find(
          (item) => String(item?.quoteProductId) === String(firstItem?.id)
        );
        setCurrentForecastView({
          ...forecastSummary,
          quotationId: currentQuotation?.id,
          quoteProductId: firstItem?.id,
          quotedAmount: calculateNetPrice(firstItem),
          quantity: firstItem?.quantity,
          productGroupName: firstItem?.productGroupName || firstItem?.groupName,
          productName: firstItem?.productName,
        });
        setShowForecastView(true);
      });
    }
  };

  const [checkedRows, setCheckedRows] = useState({})
  const [createMsg, setCreateMsg] = useState(null)

   useEffect(() => {

  if (!createMsg) return;

  const message = createMsg?.message || "";

  if (message.includes("Failed")) {
    setErrorShow({
      show: true,
      errorMessage: createMsg.successData,
    });
  } 
  else if (message.includes("Deleted successfully")) {

    setShow(true);

    if (currentForecast?.quoteProductId) {
      GetList("forecast", { quoteId: currentQuotation?.id }, setQuotationData);
    }
  }

}, [createMsg]);

  const SuccessDoneClick = () => {
    setShow(false); 
    setCreateMsg(null);
    resetForecastState();
  };
    const ErrorDoneClick = () => {
        setErrorShow({
            show: false,
            errorMessage: "",
        });
    };

    const [hoveredRow, setHoveredRow] = useState(null)

  return (
    <div className="container-fluid forecast-list-sec">
      <div className="card mt-3">
        <div className="card-body">
          {/* <!-- table-sec starts --> */}
          <section className="table-sec">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="details-table">
                   <div className="table-responsive">
                      <table className="table table-striped table-borderless forecast-summary-table">
                        <thead>
                          <tr>
                            <td>
                              <i class="fas fa-angle-left mr-2" onClick={navigateToQuotationGeneral}></i>
                              {currentQuotation?.row?.quoteReference} -{" "}
                              {currentQuotation?.row?.projectName}
                            </td>
                          
                            <td className="text-right">
                              <div className="d-flex justify-content-end align-items-center" style={{ gap: "10px" }}>
                              
                        <span>
                              Quotation Value - {currencyCode && `${currencyCode} `}{FormatValueDecimal(CurrencyConvertion(currentQuotation?.row?.grandTotal,currentQuotation?.row?.conversionRate,currencyDetail))}
                              </span>
                              {selectedForecastItems?.length > 0 ? (
                        <button
                          type="button"
                          className="btn forecast-btn"
                          onClick={openBulkForecast}
                          disabled={selectedForecastItems.length === 0}
                        >
                          New Forecast
                        </button>
                        ) : hasForecastedItems ? (
                        <button
                          type="button"
                          className="btn forecast-btn"
                          onClick={() => defaultForecastItem && OpenForecastView(defaultForecastItem)}
                        >
                          Forecast
                        </button>
                        ) : null}
                              </div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                   </div>
                </div>
                {loading ? (
                  <>
                      <SkeletonForecastListing />
                  </>
                ) : quotationData?.data?.length > 0 ? (
                <div className="table-responsive">
                  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2 px-2">
                    {/* <div>
                      <h5 className="mb-1">Products</h5>
                      <small>{selectedForecastItems.length} mark{selectedForecastItems.length === 1 ? "" : "s"} selected</small>
                    </div> */}
                   
                  </div>
                  <label className="forecast-mobile-select-all">
                    <input
                      type="checkbox"
                      checked={isAllSelectableForecastSelected}
                      disabled={selectableForecastItems.length === 0}
                      onChange={toggleAllForecastSelection}
                      ref={(input) => {
                        if (input) input.indeterminate = isPartiallySelectableForecastSelected;
                      }}
                      aria-label="Select all forecastable marks"
                      className="forecast-row-checkbox forecast-row-checkbox--select-all"
                    />
                    <span>Select all</span>
                  </label>
                  <table className="table table-striped table-borderless forecast-product-grid">
                    <thead>
                      <tr className="mt-3">
                        <th scope="col" className="forecast-select-header" style={{ width: 44, textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={isAllSelectableForecastSelected}
                            disabled={selectableForecastItems.length === 0}
                            onChange={toggleAllForecastSelection}
                            ref={(input) => {
                              if (input) input.indeterminate = isPartiallySelectableForecastSelected;
                            }}
                            aria-label="Select all forecastable marks"
                            className="forecast-row-checkbox forecast-row-checkbox--select-all"
                          />
                        </th>
                        <th scope="col" className="sort-icon">
                          Mark
                        </th>
                        <th scope="col">Product Group</th>
                        <th scope="col" className="">
                          Model Number
                        </th>
                        <th scope="col" style={{ textAlign: "right" }}>Quantity</th>
                        <th scope="col" style={{ textAlign: "right" }}>Quoted</th>
                        <th scope="col" style={{ textAlign: "right" }}>Forecasted</th>
                        <th scope="col" style={{ textAlign: "right" }}>Order Received</th>
                        <th className="text-center" scope="col">Actions</th>
                        {/* <th></th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {quotationProducts?.map((item, index) => {
                        const forecastSummary = forecastSummaryMap.get(String(item?.id));
                      return (
                        <tr key={index}
                        onMouseEnter={() => setHoveredRow(index)}
                        onMouseLeave={() => setHoveredRow(null)}>
                            <td className="forecast-select-cell" style={{ width: 44, textAlign: "center" }}>
                              <input
                                type="checkbox"
                                checked={!!selectedForecastIds?.[item?.id]}
                                disabled={isForecastedItem(item)}
                                onChange={() => toggleForecastSelection(item)}
                                aria-label={`Select ${item?.markName} for forecast`}
                                aria-disabled={!!isForecastedItem(item)}
                                title={isForecastedItem(item) ? "Already forecasted" : `Select ${item?.markName} for forecast`}
                                className={isForecastedItem(item) ? "forecast-row-checkbox forecast-row-checkbox-disabled" : "forecast-row-checkbox"}
                              />
                            </td>
                            <td>{item?.markName}</td>
                            <td>{item?.productGroupName || item?.groupName}</td>
                            <td>{item?.productName}</td>
                            <td style={{ textAlign: "right" }}>{item?.quoteQuantity}</td>
                            <td style={{ textAlign: "right" }}>{currencyCode && `${currencyCode} `}{FormatValueDecimal(CurrencyConvertion(calculateNetPrice(item), currentQuotation?.row?.conversionRate || quotationDetails?.data?.conversionRate, currencyDetail))}</td>
                            <td style={{ textAlign: "right" }}>{currencyCode && `${currencyCode} `}{FormatValueDecimal(CurrencyConvertion(forecastSummary?.forecastedAmount || 0, currentQuotation?.row?.conversionRate || quotationDetails?.data?.conversionRate, currencyDetail))}</td>
                            <td style={{ textAlign: "right" }}>0</td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center gap-2">
                                <div>
                              <span
                                class="material-symbols-rounded"
                                onClick={() => OpenProductForecast(item)}
                              >
                                bar_chart_4_bars
                              </span>
                              </div>
                        </div>
                            </td>
                      
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                ) : quotationData?.data?.length === 0 && <QuotationNotFound />}
              </div>
            </div>
          </section>
          {/* <!-- table-sec ends --> */}
        </div>
      </div>
      <div className="row">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
          <div className="save-btns">
            <button className="btn cancel-btn" onClick={navigateToQuotationGeneral}>Cancel</button>
            {/* <button className="btn save-btn">Save</button> */}
          </div>
        </div>
      </div>
      {/* // <!-- filter modal--> */}
      <AddForecast showForecast={showForecast} 
      setOpenForecast={setOpenForecast} 
      openForecast={openForecast} 
      currentForecast={currentForecast} 
      currentQuotation={currentQuotation} 
      setQuotationData={setQuotationData} 
      currencyDetail={currencyDetail}
      />
      <AddForeCastItem showForecast={showForecastItem}
      setOpenForecast={setOpenForecastItem} 
      openForecast={openForecastItem} 
      currentForecast={currentForecast} 
      currentQuotation={currentQuotation} 
      setQuotationData={setQuotationData} 
      currencyDetail={currencyDetail}
      setCheckedRows={setCheckedRows}
      checkedRows={checkedRows}
      />
      <ForecastViewModal
        show={showForecastView}
        onHide={() => {
          setShowForecastView(false);
          setCurrentForecastView(null);
        }}
        currentForecast={currentForecastView}
        currentQuotation={currentQuotation}
        forecastData={quotationData}
        currencyDetail={currencyDetail}
        setQuotationData={setQuotationData}
        forecastedItemIds={forecastedItemIds}
      />
      <BulkForecastModal
        show={showBulkForecast}
        onHide={() => setShowBulkForecast(false)}
        items={selectedForecastItems}
        quoteId={currentQuotation?.id}
        currencyDetail={currencyDetail}
        conversionRate={currentQuotation?.row?.conversionRate || quotationDetails?.data?.conversionRate}
        existingForecasts={quotationData?.data || []}
        onSaved={handleBulkForecastSaved}
      />
      <SaveSuccessModel
            createMsg={createMsg}
            setCreateMsg={setCreateMsg}
            setShow={setShow}
            show={show}
            SuccessDoneClick={SuccessDoneClick}
        />
        <ErrorMessage
            Show={errorShow?.show}
            errorMessage={errorShow?.errorMessage}
            ErrorDoneClick={ErrorDoneClick}
        />
      <div
        className="modal fade"
        id="updateStatusModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="updateStatusModalLabel"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-sm"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6>Update Quotation Status</h6>
              <i className="fas fa-times" data-dismiss="modal"></i>
            </div>
            <div className="modal-body pl-5 pr-5 pt-3 pb-5">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="mt-3">
                    <div className="mt-2">
                      <label>
                        Select Status <span className="mandatory">*</span>
                      </label>
                      <ReactSelect
                        className="basic-multi-select"
                        styles={style}
                        options={colourOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                          Option,
                        }}
                        onChange={handleChanges}
                        allowSelectAll={true}
                        value={distributertag}
                        placeholder="All"
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            neutral80: "#000000",
                          },
                        })}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="confirm-btns">
                    <button
                      type="button"
                      className="btn cancel-btn"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn submit-btn"
                      data-dismiss="modal"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forecast;
